import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    numerales: [],
  },

  getters: {
    getNumerales: (state) => state.numerales,
  },

  mutations: {
    SET_NUMERALES(state, numerales) {
      state.numerales = numerales;
    },
  },

  actions: {
    async fetchNumerales({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catNumerales')
        .then((response) => {
          commit('SET_NUMERALES', response.data.data);
        });
    },
  },
};
